'use strict';
var trackingUtils = require('../../modules/utils/tracking.utils');
var tripTypeUtils = require('../../modules/utils/trip_type');
module.exports = Odigeo.View.extend({
    selectors: {
        closeButton: '.flexible_dates_close',
        itemRoundTrip: '.flexible_dates_item_round_trip:not(.flexible_dates_item_current)',
        itemOneWay: '.flexible_dates_item_one_way:not(.flexible_dates_item_current)',
        wrapperContainer: '.flexible_dates_content',
        currentDay: '.flexible_dates_item_current',
    },
    events: {
        'click @closeButton': 'onCloseButton',
        'click @itemRoundTrip': 'searchNewDatesRoundTrip',
        'click @itemOneWay': 'searchNewDatesOneWay',
        'click @currentDay': 'onClickCurrentDay',
    },
    onClickCurrentDay: function() {
        var tripType = tripTypeUtils.toAcronym(this.model.get('tripType'));
        var label = [tripType, '_flex_days_click_current_day'].join('');
        trackingUtils.trackEvent('flex_days', label);
    },
    onCloseButton: function() {
        this.$cachedSelectors.wrapperContainer.addClass('odf-hidden');
        this.trackCloseButton();
    },
    trackCloseButton: function() {
        var tripType = tripTypeUtils.toAcronym(this.model.get('tripType'));
        var label = [tripType, '_flex_days_close_widget'].join('');
        trackingUtils.trackEvent('flex_days', label);
    },
    init: function() {
        this.model.on('refresh', this.render, this);
    },
    setTemplatesName: function() {
        var tripType = this.model.get('tripType');
        if (tripTypeUtils.isOneWay(tripType)) {
            this.templatesName = {
                item: 'flexibleDatesOneWayItem',
                wrapper: 'flexibleDatesOneWayWrapper',
            };
        } else if (tripTypeUtils.isRoundTrip(tripType)) {
            this.templatesName = {
                item: 'flexibleDatesRoundTripItem',
                wrapper: 'flexibleDatesRoundTripWrapper',
            };
        }
        Odigeo._.assign(this.templatesName, {paddingClass: Odigeo.AB.sortingTabsEnabled ? 'odf-space-outer-bottom-l' : 'odf-space-outer-bottom-s'});
    },
    render: function() {
        if (!this.model.get('isDataValid')) {
            return;
        }

        if (tripTypeUtils.isOneWay(this.model.get('tripType'))) {
            this.model.processOneWayData();
        } else {
            this.model.processRoundTripData();
        }

        if (this.model.shouldOneWayBeRendered() || this.model.shouldRoundTripBeRendered()) {
            this.renderFlexibleDates();
        }

        this.trackOnLoad();
        if (Odigeo._.gt(this.model.get('selectedPrice'), 0)) {
            this.trackPriceAccuracy();
        }
    },
    renderFlexibleDates: function() {
        this.setTemplatesName();
        var processedItems = this.processItems(this.model.get('displayedList'));
        var items = this.renderItems(processedItems);
        var searchData = JSON.parse(Odigeo.Session.get('searchParameters') || '{}');

        if ((Odigeo._.isEmpty(items) && !Odigeo.AB.isFlexibleDatesRoundTripMobile) ||
            (searchData.trainSearch)) {
            return;
        }

        this.setTemplate(this.$el, this.templatesName.wrapper, {
            wrapperContext: this.getWrapperContext(processedItems),
            items: items,
            paddingClass: this.templatesName.paddingClass,
            isColombia: this.widget.options.isColombia === 'true',
        });
    },
    getWrapperContext: function(content) {
        var savings = this.model.getPriceSavings(content);
        var textValue = this.keys.headerTextDefault;
        if (savings > this.widget.options.savingsThresholdHigh) {
            textValue = Odigeo.Utils.pluralizeAll(this.keys.headerTextLess, savings);
        } else if (savings < this.widget.options.savingsThresholdLow) {
            textValue = this.keys.headerTextCheaper;
        }
        return textValue;
    },
    renderItems: function(items) {
        return Odigeo._.reduce(
            items,
            Odigeo._.bind(function(flexibleDatesItems, item, index) {
                return flexibleDatesItems + this.templates[this.templatesName.item](Object.assign(item, {isLast: items.length - 1 === index}));
            }, this),
            ''
        );
    },
    processItems: function(days) {
        const cheaperClass = Odigeo.AB.isCssVariationMobile ? 'od-flexible-cobalt-box-price-cheapest' : 'odf-text-positive';
        return Odigeo._.map(days, function(item) {
            item.currentDayClasses = item.searched ? 'flexible_dates_item_current' : '';
            item.cheaperDay = item.cheaper || item.cheapest ? cheaperClass : '';
            item.price = item.price ? item.price : '-';
            item.priceFormatted = item.priceFormatted ? item.priceFormatted : '-';
            return item;
        });
    },
    searchNewDatesRoundTrip: function(event) {
        var item = this.model.getItemFromIndex($(event.currentTarget).data('index'));
        this.trackSelectItem(item);
        this.model.updateSelectedData({
            price: item.price,
            departureDate: item.departureDate,
            returnDate: item.returnDate,
        });
        this.searchNewDatesOneWayNewSearch();
    },
    searchNewDatesOneWay: function(event) {
        var item = this.model.getOneWayEntryWithOffset(event.currentTarget.getAttribute('data-offset'));
        if (item) {
            this.trackSelectItem(item);
            this.model.updateSelectedData({
                price: item.apparentPrices.amount,
                departureDate: item.departureDate,
            });
            this.searchNewDatesOneWayNewSearch();
        }
    },
    searchNewDatesOneWayNewSearch: function() {
        Odigeo.trigger(this.widget.id + ':search');
    },
    trackPriceAccuracy: function() {
        var label = [
            'flex_accuracity_dif:',
            this.model.getTrackingPriceDifference(),
            '_pf:',
            Math.round(this.model.get('selectedPrice')),
            '_pr:',
            Math.round(this.model.get('cheapestPrice')),
            '_',
            this.model.get('usesCount'),
        ].join('');
        var action = 'flex_days_' + tripTypeUtils.toAcronym(this.model.get('tripType'));
        trackingUtils.trackEvent(action, label);
    },

    trackOnLoad: function() {
        var label = [
            tripTypeUtils.toAcronym(this.model.get('tripType')),
            '_flex_days_op:',
            this.model.getNumOptionsForTracking(),
            '_pr:',
            Math.round(this.model.get('cheapestPrice')),
            '_pc:',
            Math.round(this.model.getCheapestDisplayDay()),
            '_pe:',
            Math.round(this.model.getExpensiveDisplayDay()),
            '_',
            this.model.get('usesCount'),
        ].join('');
        trackingUtils.trackEvent('on_load', label);
    },
    trackSelectItem: function(item) {
        var searchParameters = this.model.get('searchParameters');
        var trackInfo = {
            departureDifference: this.getDaysDifference(searchParameters.searchSegments[0].dateStr, item.departureDate),
            returnDifference: 'NA',
            selectedPrice: item.price,
            cheapest: item.cheapest,
        };
        if (tripTypeUtils.isRoundTrip(this.model.get('tripType'))) {
            trackInfo.returnDifference = this.getDaysDifference(searchParameters.searchSegments[1].dateStr, item.returnDate);
        }
        this.trackSelectDay(trackInfo);
    },
    getDaysDifference: function(firstDate, secondDate) {
        return Odigeo.Utils.getDifferenceInDays(Odigeo.Utils.parseDate(firstDate).getTime(), Odigeo.Utils.parseDate(secondDate).getTime());
    },
    trackSelectDay: function(info) {
        var label = [
            tripTypeUtils.toAcronym(this.model.get('tripType')),
            '_flex_days_dd:',
            info.departureDifference,
            '_dr:',
            info.returnDifference,
            '_pr:',
            Math.round(this.model.get('cheapestPrice')),
            '_ps:',
            info.selectedPrice,
            '_che:',
            info.cheapest ? 'YES' : 'NO',
            '_',
            this.model.get('usesCount'),
        ].join('');
        trackingUtils.trackEvent('flex_days', label);
    },
    cleanView: function() {
        this.$el.empty();
    },
    toggleFlexibleDates(isFirstBatch) {
        this.$el.toggleClass('odf-hidden', isFirstBatch);
    },
});
